import { createFileRoute, redirect } from "@tanstack/react-router"
import { getLearningPathWithModules } from "@/api/services/learningPaths"
import { learningPathsQueryKeys } from "@/api/query-keys/learningPaths"
import { checkPermissions } from "@/utils/checkPermissions"

export const Route = createFileRoute("/beheer/leerlijnen/$learningPathId/")({
  beforeLoad: async ({ params, context }) => {
    checkPermissions("read", "curriculum")
    const { queryClient } = context

    const { data: learningPath } = await queryClient.fetchQuery({
      queryKey: learningPathsQueryKeys.detail(Number(params.learningPathId)),
      queryFn: () => getLearningPathWithModules(Number(params.learningPathId)),
    })

    const firstModule = learningPath.modules[0]
    if (firstModule) {
      throw redirect({
        to: "/beheer/leerlijnen/$learningPathId/modules/$moduleId",
        params: {
          learningPathId: params.learningPathId,
          moduleId: firstModule.id.toString(),
        },
      })
    }
  },
})
